console.log("app-custom.js loaded");

function replaceSwymDoneText() {
  document.querySelectorAll('.swym-wishlist-done-btn').forEach((btn) => {
    const currentText = btn.textContent.trim();
    if (currentText.includes('完了 (Kanryō)')) {
      btn.textContent = '追加'; 
      console.log('Swym button text replaced');
    }
  });
}


replaceSwymDoneText();

const observer = new MutationObserver(() => {
  replaceSwymDoneText();
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});


document.addEventListener('DOMContentLoaded', function() {
    const reviewWidget = document.querySelector('#judgeme_product_reviews, .judgeme_product_reviews');
    
    if (reviewWidget) {
        setTimeout(function() {
            // 計算済みスタイルを取得
            const computedStyle = window.getComputedStyle(reviewWidget);

            if (computedStyle.display === 'none') {
                const noReviewsMessage = document.createElement('p');
                noReviewsMessage.textContent = 'レビューはまだありません';
                
                // メッセージのスタイルを調整 (任意)
                noReviewsMessage.style.textAlign = 'center';
                noReviewsMessage.style.padding = '20px 0';
                noReviewsMessage.style.fontSize = '1.1em';
                noReviewsMessage.style.color = '#333'; 
                
                reviewWidget.parentNode.insertBefore(noReviewsMessage, reviewWidget);
            }
        }, 400);
    }
});
